module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "ch2"
    }
  }), _c('em', [_vm._v("Acts of God")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "lev1"
    }
  }), _vm._v("I. Tornado")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I said the people come inside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("They would be safe")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in the building.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("So many of those people die.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can see my guilt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I could see hands")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("to a lady moving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I knew the lady.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can see my guilt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Sometimes I want to run, to get")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("away from it. I ask forgiveness")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("night and day, I ask it from")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the cemetery. I can never")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("dream this storm away.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("It was over for maybe minutes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("then it was never over.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "lev2"
    }
  }), _vm._v("II. Lightning")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("It pushed me backward, I could see")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("my friends go backward, too,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("as from a blast, but slowly,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("very slowly, everything was in")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("a different time.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("It burned inside my body.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I could feel my hands")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("curl up. My pocket got")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("on fire, I didn’t want")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("to reach in there and take")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("a handful of the hot.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My money hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I’m different now forever, put that fact")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("into your book. My hair used to be straight.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My eyes—you see? They’re gray as ash.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("They used to be light blue. You live,")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("if you’re lucky, but take my word—")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("it changes how you look.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-180e189c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter02.vue
// module id = 87
// module chunks = 0